import React, { useMemo } from 'react';
import './DailyActivity.css';
import { formatNumber } from '../../../utils/analyticsHelpers';

// Total events for a day. The backend only returns per-event-type counts
// (searches, tripViews, bookingStarted, ...), not a combined total, so we
// add them up here for the "Events" column.
const getDayEventTotal = (day) => {
    return (
        Number(day.searches || 0) +
        Number(day.tripViews || 0) +
        Number(day.bookingStarted || 0) +
        Number(day.checkoutStarted || 0) +
        Number(day.paymentInitiated || 0) +
        Number(day.paymentSuccess || 0) +
        Number(day.paymentFailed || 0) +
        Number(day.bookingConfirmed || 0)
    );
};

const DailyActivity = ({ daily = [] }) => {
    const recentDaily = useMemo(() => daily.slice(-7), [daily]);

    return (
        <section className='analyticsSection dailySection'>
            <div className='analyticsSectionHeader'>
                <div>
                    <h2>Daily Activity</h2>

                    <span>User activity by day</span>
                </div>
            </div>

            {recentDaily.length === 0 ? (
                <div className='analyticsEmpty'>No activity found</div>
            ) : (
                <div className='dailyCompactTable'>
                    <div className='dailyCompactHeader'>
                        <span>Date</span>

                        <span>Users</span>

                        <span>Sessions</span>

                        <span>Events</span>
                    </div>

                    {recentDaily.map((item, index) => (
                        <div className='dailyCompactRow' key={item.date || index}>
                            <span>{item.date}</span>

                            <span>{formatNumber(item.users)}</span>

                            <span>{formatNumber(item.sessions)}</span>

                            <span>{formatNumber(getDayEventTotal(item))}</span>
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
};

export default DailyActivity;
